import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-01/lesson-21/task-01";

const task: Slide = {
  titleHtml: `Which modes of the 2D cavity shown below are excited<br>when the source is located at the following place?`,
  description: "Connect with lines.",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 1,
      components: [
        [
          {
            variant: "__task__",
            data: {
              id: task01.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
